<template>
  <div
    v-if="gameboard === 'where-in-the-world'"
    id="mainGame"
    class="navigation"
    :class="gameboard"
  >
    <WhereInTheWorldGameBoard
      :gameID="this.gameID"
      :gameboard="gameboard"
      :challenges="challenges"
      :challengeSelectionText="challengeSelectionText"
      @challengeSelected="challengeSelected"
      @completedChallengeSelected="completedChallengeSelected"
      @blockedChallengeSelected="blockedChallengeSelected"
    >
    </WhereInTheWorldGameBoard>
  </div>
  <div
    v-else-if="challengeListEmbed"
    id="mainGame"
    class="navigation"
    :class="gameboard || 'big-escape'"
  >
    <div style="height:100%;width:100%">
      <!-- Gameboard Row 1 -->

      <Embed
        class="gameboard-grid-row"
        style="height:100% !important;width:100%"
        :gameID="gameID"
        :source="challengeListEmbed"
        @hotspot-clicked="hotspotClicked"
      />

      <!-- End of Gameboard Row 1 -->

      <!-- <div class="row"> -->
      <div
        class="ggcfooter"
        style="zorder: 150; position: fixed !important; bottom: 10px; z-index: 2;"
      >
        <h2>{{ challengeSelectionText }}</h2>
      </div>
      <!-- </div> -->
    </div>
  </div>
  <div
    v-else-if="gameboard === 'the-perfect-pitch'"
    id="mainGame"
    class="navigation the-perfect-pitch"
  >
    <div class="gameboard">
      <!-- Gameboard Row 1 -->
      <div class="gameboard-grid-row">
        <!-- Button 1 -->
        <div class="gameboard-grid-third justify-center align-content-center">
          <div
            style="pointer-event: none !important;"
            class="gameboard-button gameboard-tpp-button-yellow blue-back justify-center align-content-center"
          >
            <a>
              <ul>
                <li>
                  <h3>Let's get<br />Started !!</h3>
                </li>
              </ul>
            </a>
          </div>
        </div>
        <!-- Button 1 -->

        <!-- Button 2 -->
        <div
          v-for="(challenge, index) in challenges"
          :key="index"
          class="gameboard-grid-third justify-center align-content-center"
        >
          <div
            class="gameboard-button justify-center align-content-center"
            :class="perfectPitchClassesForChallengeIndex(index)"
          >
            <a
              :style="
                !isChallengeBlocked(challenge) &&
                  !challenge.complete &&
                  'cursor: pointer'
              "
              @click="chooseChallenge(index)"
            >
              <ul
                :class="[
                  challenge.complete && 'completed',
                  isChallengeBlocked(challenge) && 'locked'
                ]"
              >
                <li class="gameboard-question-indicator-tpp">
                  {{ index + 1 }}
                </li>
                <li>
                  <div
                    v-if="selectedChallengeIndex === index"
                    class="button-loading-spinner"
                  ></div>
                  <h3 v-else>{{ challenge.title }}</h3>
                </li>
                <li
                  v-if="!isChallengeBlocked(challenge) && !challenge.complete"
                  class="gameboard-play-indicator-tpp"
                >
                  Play Now
                </li>
              </ul>
            </a>
          </div>
        </div>
        <!-- Button 2 -->
      </div>
      <!-- End of Gameboard Row  -->

      <div class="row">
        <div class="ggcfooter">
          <h2>{{ challengeSelectionText }}</h2>
        </div>
      </div>
    </div>
  </div>
  <div
    v-else
    id="mainGame"
    class="navigation"
    :class="gameboard || 'big-escape'"
  >
    <div class="gameboard">
      <!-- Gameboard Row 1 -->
      <div class="gameboard-grid-row">
        <!-- Button 1 -->
        <div
          v-for="(challenge, index) in challenges"
          :key="index"
          class="justify-center align-content-center"
          :class="bigEscapeClassesForChallengeIndex(index)"
        >
          <div
            class="gameboard-button gameboard-button justify-center align-content-center"
            :class="{
              numeric_title: !isNaN(challenge.title),
              text_title: !isNaN(challenge.title)
            }"
          >
            <a
              :style="
                !isChallengeBlocked(challenge) &&
                  !challenge.complete &&
                  'cursor: pointer'
              "
              @click="chooseChallenge(index)"
            >
              <ul
                :class="[
                  challenge.complete && 'completed',
                  isChallengeBlocked(challenge) && 'locked'
                ]"
              >
                <li class="gameboard-play-indicator">
                  <div class="shadow-outer">
                    <img
                      :src="resolveGameAssetURL(gameID, challenge.image)"
                      :alt="challenge.title"
                    />
                    <div class="shadowred"></div>
                    <img src="../assets/images/lock.svg" class="lock" />
                    <img src="../assets/images/tick.svg" class="tick" />
                  </div>
                </li>
                <li
                  :class="{
                    points_challenge: !isNaN(challenge.title)
                  }"
                >
                  <div
                    v-if="selectedChallengeIndex === index"
                    class="button-loading-spinner"
                  ></div>
                  <span v-else>{{ challenge.title }}</span>
                </li>
              </ul>
            </a>
          </div>
        </div>
        <!-- Button 1 -->
      </div>
      <!-- End of Gameboard Row 1 -->

      <div class="row">
        <div class="ggcfooter">
          <h2>{{ challengeSelectionText }}</h2>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { gameAssetsMixin } from '../mixins/gameAssetsMixin'
import WhereInTheWorldGameBoard from '@/components/WhereInTheWorldGameBoard.vue'
import Embed from '@/components/Embed.vue'

export default {
  mixins: [gameAssetsMixin],
  components: {
    Embed,
    WhereInTheWorldGameBoard
  },
  data: () => ({
    selectedChallengeIndex: null
  }),
  props: {
    gameID: { type: String, required: true },
    gameboard: { type: String, required: false },
    challenges: { type: Array, required: true },
    challengeSelectionText: { type: String, required: true },
    challengeListEmbed: String
  },
  created() {},
  methods: {
    bigEscapeClassesForChallengeIndex() {
      if (this.gameID === 'murder-mystery' || this.gameID === '60') {
        return ['gameboard-grid-third-mm']
      }

      return ['gameboard-grid-third']
    },
    perfectPitchClassesForChallengeIndex(index) {
      switch (index) {
        case 0:
          return ['gameboard-tpp-button-yellow']
        case 1:
          return ['gameboard-tpp-button-pink']
        case 2:
          return ['gameboard-tpp-button-green']
        case 3:
          return ['gameboard-tpp-button-blue']
        case 4:
          return ['gameboard-tpp-button-blue', 'orange-back']
      }

      return null
    },
    chooseChallenge(index) {
      if (this.isChallengeBlocked(this.challenges[index])) {
        console.log(
          'That challenge is currently locked. Choose another challenge.'
        )
        this.$emit('blockedChallengeSelected', index)
        return
      }

      if (this.challenges[index].complete) {
        console.log(
          'That challenge is already complete. Choose another challenge.'
        )
        this.$emit('completedChallengeSelected', index)
        return
      }

      this.selectedChallengeIndex = index
      setTimeout(() => {
        this.selectedChallengeIndex = null
      }, 3000)

      this.$emit('challengeSelected', index)
    },
    isChallengeBlocked(challenge) {
      for (const blockingIndex of challenge.blockedBy) {
        if (!this.challenges[blockingIndex].complete) {
          return true
        }
      }

      let completeCountRequired = challenge.blockedBeforeCompleteCount || 0

      if (completeCountRequired > 0) {
        let currentCompleteCount = this.challenges.filter(
          challenge => challenge.complete
        ).length

        if (currentCompleteCount < completeCountRequired) {
          return true
        }
      }

      return false
    },
    hotspotClicked(hotspotData) {
      console.log(`🎯🎯🎯 Hotspot clicked: ${hotspotData}`)

      const index = this.challenges.findIndex(challenge => {
        return challenge.tag === hotspotData
      })

      if (index != -1) {
        this.chooseChallenge(index)
      } else {
        console.log(`Unknown hotspot clicked: ${hotspotData}`)
      }
    },
    challengeSelected(index) {
      this.$emit('challengeSelected', index)
    },
    blockedChallengeSelected() {
      this.$emit('blockedChallengeSelected')
    },
    completedChallengeSelected() {
      this.$emit('completedChallengeSelected')
    }
  }
}
</script>

<style scoped></style>
